import React from 'react';

export default function Title(props: any) {
  return (
    <div className="title" style={{ opacity: props.opacity }}>
      &nbsp;&nbsp;&nbsp;&nbsp;LIVE SATELLITE | GREAT BARRIER REEF
    </div>
  )
}